export enum UserPanelModule {
  SETTINGS = 'SETTINGS',
  OPINIONS = 'OPINIONS',
  LOGGING = 'LOGGING',
  CUSTOM_LOGO = 'CUSTOM_LOGO',
  BIG_BIK_QUERIES = 'BIG_BIK_QUERIES',
}
